import React from 'react';
import { FormGroup, Checkbox } from '@zen-common/components-base';

export default function IncludeAuthenticationFormGroup() {
  return (
    <FormGroup>
      <Checkbox label="Include Authentication" checked disabled />
    </FormGroup>
  );
}
